export { default } from './researchers';
export { default as ResearchersStub } from './researchers.stub';
